<mat-card appearance="outlined" class="syn-card" fxLayout="column" fxLayoutAlign="space-around stretch">
    <mat-card-header *ngIf="message">
        <mat-card-title>
            {{ message }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field class="filter" appearance="outline">
            <mat-label>Filtrer</mat-label>
            <input
                #filter
                matInput
                type="text"
                (keyup)="applyFilter($event.target.value)"
                placeholder="Filtrer"
            />
            <button
                mat-icon-button
                matSuffix
                (click)="applyFilter('')"
            >
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </mat-form-field>
        <mat-table #table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>

                <mat-cell *matCellDef="let row">
                    <syn-ticket-avatar [ticket]="row" [showId]="true" [size]=24></syn-ticket-avatar>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="subject">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Sujet </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.subject}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="project">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <syn-project-avatar
                        [size]="24"
                        [project]="getProject(row.project)"
                        [showLegend]="true">
                    </syn-project-avatar>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Statut </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.status}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.type}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="isPrivate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Interne </mat-header-cell>
                <mat-cell *matCellDef="let row"> <syn-boolean-ico [check]="row.isPrivate"></syn-boolean-ico> </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tags">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Tags </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-chip-listbox>
                        <mat-chip disableRipple disabled class="readonly-chip" *ngFor="let tag of row.tags">{{tag}}</mat-chip>
                    </mat-chip-listbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Date de création </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{legibleDate(row.createdAt)}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <mat-paginator *ngIf="showPaginator" #paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>
    </mat-card-content>
</mat-card>
